<template>
  <div class="sign-up">
    <img src="../assets/PEC-Logo-1.png" width="300px">
     <v-form align-center>
          <v-container fluid>
            <h3>Create a new account</h3>
            <v-layout align-center justify-center>
              <v-flex
                xs12
                md3>
                <v-text-field
                  v-model="email" 
                  label="Email" 
                  required></v-text-field>
              </v-flex>
            <br>
             <v-flex
                xs12
                md3>
                <v-text-field 
                  v-model="password"
                  type="password" 
                  label="Password" 
                  required></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
     </v-form>
    
    <br>
    <v-btn v-on:click="signUp" class="button">Sign Up!</v-btn>
    <v-btn class="button">
      <router-link to="/login">
        Back
      </router-link>
    </v-btn>
  </div>
</template>

<script>
  import firebase from 'firebase'
  export default {
    name: 'signup',
    data () {
      return {
        email: '',
        password: ''
      }
    },
    methods: {
      signUp () {
        firebase.auth().createUserWithEmailAndPassword(this.email, this.password).then((user) => {
          this.$router.replace('/login')
        }).catch((err) => {
          alert(err.message)
        });
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/SignUp.vue